// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3abQ-","comment":"styles_comment__3kfi1"};